export const environment = {
  environment: 'development',
  production: false,
  baseUrl: 'https://api-marid-u8sdhqax.eleganteq.dev',
  apiUrl: 'https://api-marid-u8sdhqax.eleganteq.dev/admin',
  mediaUrl: '',
  qitaf: {
    branchId: ' 26030000',
    terminalId: '26030000',
  },
  otp: {
    useTestMode: true,
  },
};
